import React, { Component } from "react";

import { connect } from "react-redux";

import { sdg1671bActions } from "../../../../../../_actions";
import { TextInput } from "carbon-components-react";

class ProportionsTable extends Component {
  constructor(props) {
    super(props);

    this.state = {
      data: props.data,
      error: props.error,
      editingFields: {},
      focusedFields: {}
    };

    this.handleTableChange = this.handleTableChange.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleFocus = this.handleFocus.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.goToMetadata = this.goToMetadata.bind(this);
    this.getProportionsColumns = this.getProportionsColumns.bind(this);
  }

  handleTableChange(e) {
    let { dispatch } = this.props;
    let target = e.target.name.split(":");
    dispatch(
      sdg1671bActions.updateDataField(parseInt(target[0]), target[1], e.target.value)
    );
  }

  handleChange(e) {
    const isOGC = this.props.user && this.props.user.user_type === "OGC";
    if (isOGC) {
      this.setState({
        editingFields: {
          ...this.state.editingFields,
          [e.target.name]: e.target.value
        }
      });
    }
  }

  handleFocus(e) {
    const isOGC = this.props.user && this.props.user.user_type === "OGC";
    if (isOGC) {
      const storedValue =
        this.props.data && this.props.data.proportions && this.props.data.proportions[0]
          ? this.props.data.proportions[0][e.target.name]
          : null;

      this.setState({
        focusedFields: {
          ...this.state.focusedFields,
          [e.target.name]: true
        },
        editingFields: {
          ...this.state.editingFields,
          [e.target.name]:
            storedValue === null || storedValue === undefined || storedValue === 0
              ? ""
              : String(storedValue)
        }
      });
    }
  }

  handleBlur(e) {
    const isOGC = this.props.user && this.props.user.user_type === "OGC";
    if (isOGC) {
      const inputValue = e.target.value.trim();
      let value;
      if (inputValue === "" || inputValue === "0" || inputValue === "0.00" || inputValue === "0.0") {
        value = null;
      } else {
        const parsed = parseFloat(inputValue);
        value = isNaN(parsed) ? null : parsed;
      }

      let { dispatch } = this.props;
      dispatch(sdg1671bActions.updateProportions(e.target.name, value));

      const newEditingFields = { ...this.state.editingFields };
      const newFocusedFields = { ...this.state.focusedFields };
      delete newEditingFields[e.target.name];
      delete newFocusedFields[e.target.name];
      this.setState({ editingFields: newEditingFields, focusedFields: newFocusedFields });
    }
  }

  goToMetadata() {
    this.props.onPrevious();
  }

  // ─── Can-calculate helpers ─────────────────────────────────────────────────

  canCalculateProportionsColumn(index, column1, column2) {
    if (!this.props.data || !this.props.data.data) return false;
    const hasIndex =
      this.props.data.data[index] &&
      this.props.data.data[index][column1] !== null &&
      this.props.data.data[index][column1] !== undefined;
    const hasTotal =
      this.props.data.data[2] &&
      this.props.data.data[2][column2] !== null &&
      this.props.data.data[2][column2] !== undefined &&
      parseInt(this.props.data.data[2][column2]) !== 0;
    return hasIndex && hasTotal;
  }

  canCalculateProportionsRowTotal(column1) {
    if (!this.props.data || !this.props.data.data) return false;
    return (
      this.props.data.data[2] &&
      this.props.data.data[2][column1] &&
      parseInt(this.props.data.data[2][column1]) !== 0 &&
      !!this.props.data.data[2]["total_national"]
    );
  }

  canCalculateYoungTotals() {
    return (
      this.canCalculateProportionsRowTotal("below_25") ||
      this.canCalculateProportionsRowTotal("age_25_34")
    );
  }

  // ─── Raw calculation helpers (unchanged from original) ────────────────────

  getTotalRowNumber(row) {
    let val = 0;
    if (this.props.data && this.props.data.data[0][row]) {
      val += parseInt(this.props.data.data[0][row]);
    }
    if (this.props.data && this.props.data.data[1][row]) {
      val += parseInt(this.props.data.data[1][row]);
    }
    return val;
  }

  getTotalNumber(index, prefix) {
    let val = 0;
    if (this.props.data && this.props.data.data[index][prefix + "_officials"]) {
      val += parseInt(this.props.data.data[index][prefix + "_officials"]);
    }
    if (this.props.data && this.props.data.data[index][prefix + "_executives"]) {
      val += parseInt(this.props.data.data[index][prefix + "_executives"]);
    }
    if (this.props.data && this.props.data.data[index][prefix + "_professionals"]) {
      val += parseInt(this.props.data.data[index][prefix + "_professionals"]);
    }
    if (this.props.data && this.props.data.data[index][prefix + "_associate"]) {
      val += parseInt(this.props.data.data[index][prefix + "_associate"]);
    }
    if (this.props.data && this.props.data.data[index][prefix + "_general"]) {
      val += parseInt(this.props.data.data[index][prefix + "_general"]);
    }
    return val;
  }

  getProportionsColumns(index, column1, column2, name) {
    if (
      this.props.data &&
      this.props.data.data[index][column1] !== null &&
      this.props.data.data[2][column2] &&
      this.props.data.data[2][column2] !== 0
    ) {
      return ((parseInt(this.props.data.data[index][column1]) / parseInt(this.props.data.data[2][column2])) * 100.0).toFixed(2);
    }
    return 0;
  }

  getProportionsTotalsRow(column1, column2) {
    if (this.props.data && this.props.data.data[2][column1] && parseInt(this.props.data.data[2][column1]) !== 0) {
      return ((parseInt(this.props.data.data[2][column1]) / parseInt(this.props.data.data[2][column2])) * 100.0).toFixed(2);
    }
    return 0;
  }

  getProportionsRowTotals(column1) {
    if (
      this.props.data &&
      this.props.data.data[2][column1] &&
      parseInt(this.props.data.data[2][column1]) !== 0 &&
      this.props.data.data[2]["total_national"]
    ) {
      return ((parseInt(this.props.data.data[2][column1]) / parseInt(this.props.data.data[2]["total_national"])) * 100.0).toFixed(2);
    }
    return 0;
  }

  getProportionsColumnTotals(index, column1) {
    if (this.props.data && parseInt(this.getTotalNumber(index, column1)) !== 0) {
      return ((parseInt(this.getTotalNumber(index, column1)) / parseInt(this.props.data.data[2]["total_national"])) * 100.0).toFixed(2);
    }
    return 0;
  }

  getYoungTotalsRaw() {
    return (
      parseFloat(this.getProportionsRowTotals("below_25")) +
      parseFloat(this.getProportionsRowTotals("age_25_34"))
    ).toFixed(2);
  }

  // ─── Unified value getter ──────────────────────────────────────────────────

  /**
   * Returns the value to display in a proportion cell.
   * - If the proportion can be calculated from raw data: returns calculated value
   *   and syncs it to Redux if it has changed.
   * - If it cannot be calculated and the OGC admin is actively editing: returns
   *   the in-progress local value.
   * - Otherwise: returns the stored Redux value (or "0.00" as fallback).
   */
  getProportionValue(canCalculate, calculatedValue, name) {
    if (canCalculate) {
      const calc = parseFloat(calculatedValue).toFixed(2);
      if (
        this.props.data &&
        this.props.data.proportions &&
        this.props.data.proportions[0] &&
        parseFloat(this.props.data.proportions[0][name]).toFixed(2) !== calc
      ) {
        let { dispatch } = this.props;
        dispatch(sdg1671bActions.updateProportions(name, parseFloat(calc)));
      }
      return calc;
    }

    const isOGC = this.props.user && this.props.user.user_type === "OGC";
    if (isOGC && this.state.editingFields && this.state.editingFields[name] !== undefined) {
      return this.state.editingFields[name];
    }

    if (this.props.data && this.props.data.proportions && this.props.data.proportions[0]) {
      const stored = this.props.data.proportions[0][name];
      if (stored === null || stored === undefined || stored === 0) {
        return "0.00";
      }
      return parseFloat(stored).toFixed(2);
    }

    return "0.00";
  }

  render() {
    const isOGC = this.props.user && this.props.user.user_type === "OGC";

    // ── can-calculate flags ──────────────────────────────────────────────────
    const canCalcFemaleSenior   = this.canCalculateProportionsColumn(1, "total_officials",   "total_officials");
    const canCalcFemaleOther    = this.canCalculateProportionsColumn(1, "total_executives",  "total_executives");
    const canCalcFemaleProf     = this.canCalculateProportionsColumn(1, "total_professionals","total_professionals");
    const canCalcFemaleAssoc    = this.canCalculateProportionsColumn(1, "total_associate",   "total_associate");
    const canCalcFemaleGeneral  = this.canCalculateProportionsColumn(1, "total_general",     "total_general");
    const canCalcFemaleNational = this.canCalculateProportionsColumn(1, "total_national",    "total_national");
    const canCalcBelow25        = this.canCalculateProportionsRowTotal("below_25");
    const canCalcYoung          = this.canCalculateYoungTotals();
    const canCalcDisabled       = this.canCalculateProportionsRowTotal("disability");
    const canCalcGroupA         = this.canCalculateProportionsRowTotal("group_a_value");
    const canCalcGroupB         = this.canCalculateProportionsRowTotal("group_b_value");
    const canCalcGroupC         = this.canCalculateProportionsRowTotal("group_c_value");

    return (
      <React.Fragment>
        <div className="box-body">
          <div className="col-sm-8">
            <h3>TABLE 2: Proportions</h3>
          </div>
          <div className="row">
            <div className="col-sm-12 adaptive-table">
              <fieldset
                disabled={this.props.data && (!this.props.data.id || this.props.data.id === null)}
              >
                <table className="table table-bordered table-1671b">
                  <thead>
                    <tr>
                      <th width="35%"></th>
                      <th>
                        Proportion of female public servants
                      </th>
                      <th>
                        Proportion of 'young' public servants below 25
                      </th>
                      <th>
                        Proportion of 'young' public servants aged 34 and below
                      </th>
                      <th>
                        Proportion of public servants with a disability
                      </th>
                      <th>
                        Proportion of public servants in population group A
                      </th>
                      <th>
                        Proportion of public servants in population group B
                      </th>
                      <th>
                        Proportion of public servants in population group C
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td style={{background:"#A9D08E"}} colSpan="8">Total public service personnel
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Senior Managers: Senior Government Officials
                      </td>
                      <td>
                        <TextInput
                          id="female_senior_managers"
                          name="female_senior_managers"
                          labelText=""
                          onChange={this.handleChange}
                          onFocus={this.handleFocus}
                          onBlur={this.handleBlur}
                          value={this.getProportionValue(
                            canCalcFemaleSenior,
                            this.getProportionsColumns(1, "total_officials", "total_officials", "female_senior_managers"),
                            "female_senior_managers"
                          )}
                          disabled={!isOGC || canCalcFemaleSenior}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Other Managers: Managing Directors and Chief Executives and Business Services and Administration Managers
                      </td>
                      <td>
                        <TextInput
                          id="female_other_managers"
                          name="female_other_managers"
                          labelText=""
                          onChange={this.handleChange}
                          onFocus={this.handleFocus}
                          onBlur={this.handleBlur}
                          value={this.getProportionValue(
                            canCalcFemaleOther,
                            this.getProportionsColumns(1, "total_executives", "total_executives", "female_other_managers"),
                            "female_other_managers"
                          )}
                          disabled={!isOGC || canCalcFemaleOther}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Administration Professionals
                      </td>
                      <td>
                        <TextInput
                          id="female_administration_professionals"
                          name="female_administration_professionals"
                          labelText=""
                          onChange={this.handleChange}
                          onFocus={this.handleFocus}
                          onBlur={this.handleBlur}
                          value={this.getProportionValue(
                            canCalcFemaleProf,
                            this.getProportionsColumns(1, "total_professionals", "total_professionals", "female_administration_professionals"),
                            "female_administration_professionals"
                          )}
                          disabled={!isOGC || canCalcFemaleProf}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Business and Administration Associate Professionals
                      </td>
                      <td>
                        <TextInput
                          id="female_ba_associate_professionals"
                          name="female_ba_associate_professionals"
                          labelText=""
                          onChange={this.handleChange}
                          onFocus={this.handleFocus}
                          onBlur={this.handleBlur}
                          value={this.getProportionValue(
                            canCalcFemaleAssoc,
                            this.getProportionsColumns(1, "total_associate", "total_associate", "female_ba_associate_professionals"),
                            "female_ba_associate_professionals"
                          )}
                          disabled={!isOGC || canCalcFemaleAssoc}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        General and Keyboard Clerks
                      </td>
                      <td>
                        <TextInput
                          id="female_gk_clerks"
                          name="female_gk_clerks"
                          labelText=""
                          onChange={this.handleChange}
                          onFocus={this.handleFocus}
                          onBlur={this.handleBlur}
                          value={this.getProportionValue(
                            canCalcFemaleGeneral,
                            this.getProportionsColumns(1, "total_general", "total_general", "female_gk_clerks"),
                            "female_gk_clerks"
                          )}
                          disabled={!isOGC || canCalcFemaleGeneral}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Total national-level public service personnel (including police, education, health, front-desk administrative and all other public service personnel)
                      </td>
                      <td>
                        <TextInput
                          id="female_total_national"
                          name="female_total_national"
                          labelText=""
                          onChange={this.handleChange}
                          onFocus={this.handleFocus}
                          onBlur={this.handleBlur}
                          value={this.getProportionValue(
                            canCalcFemaleNational,
                            this.getProportionsColumns(1, "total_national", "total_national", "female_total_national"),
                            "female_total_national"
                          )}
                          disabled={!isOGC || canCalcFemaleNational}
                        />
                      </td>
                      <td>
                        <TextInput
                          id="bellow25_total_national"
                          name="bellow25_total_national"
                          labelText=""
                          onChange={this.handleChange}
                          onFocus={this.handleFocus}
                          onBlur={this.handleBlur}
                          value={this.getProportionValue(
                            canCalcBelow25,
                            this.getProportionsRowTotals("below_25"),
                            "bellow25_total_national"
                          )}
                          disabled={!isOGC || canCalcBelow25}
                        />
                      </td>
                      <td>
                        <TextInput
                          id="bellow34_total_national"
                          name="bellow34_total_national"
                          labelText=""
                          onChange={this.handleChange}
                          onFocus={this.handleFocus}
                          onBlur={this.handleBlur}
                          value={this.getProportionValue(
                            canCalcYoung,
                            this.getYoungTotalsRaw(),
                            "bellow34_total_national"
                          )}
                          disabled={!isOGC || canCalcYoung}
                        />
                      </td>
                      <td>
                        <TextInput
                          id="disabled_total_national"
                          name="disabled_total_national"
                          labelText=""
                          onChange={this.handleChange}
                          onFocus={this.handleFocus}
                          onBlur={this.handleBlur}
                          value={this.getProportionValue(
                            canCalcDisabled,
                            this.getProportionsRowTotals("disability"),
                            "disabled_total_national"
                          )}
                          disabled={!isOGC || canCalcDisabled}
                        />
                      </td>
                      <td>
                        <TextInput
                          id="population_a_total_national"
                          name="population_a_total_national"
                          labelText=""
                          onChange={this.handleChange}
                          onFocus={this.handleFocus}
                          onBlur={this.handleBlur}
                          value={this.getProportionValue(
                            canCalcGroupA,
                            this.getProportionsRowTotals("group_a_value"),
                            "population_a_total_national"
                          )}
                          disabled={!isOGC || canCalcGroupA}
                        />
                      </td>
                      <td>
                        <TextInput
                          id="population_b_total_national"
                          name="population_b_total_national"
                          labelText=""
                          onChange={this.handleChange}
                          onFocus={this.handleFocus}
                          onBlur={this.handleBlur}
                          value={this.getProportionValue(
                            canCalcGroupB,
                            this.getProportionsRowTotals("group_b_value"),
                            "population_b_total_national"
                          )}
                          disabled={!isOGC || canCalcGroupB}
                        />
                      </td>
                      <td>
                        <TextInput
                          id="population_c_total_national"
                          name="population_c_total_national"
                          labelText=""
                          onChange={this.handleChange}
                          onFocus={this.handleFocus}
                          onBlur={this.handleBlur}
                          value={this.getProportionValue(
                            canCalcGroupC,
                            this.getProportionsRowTotals("group_c_value"),
                            "population_c_total_national"
                          )}
                          disabled={!isOGC || canCalcGroupC}
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </fieldset>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  const { data } = state.sdg1671bState;
  const { user } = state.authentication;

  return {
    data,
    user
  };
}

const connectedIndicatorData = connect(mapStateToProps)(ProportionsTable);

export { connectedIndicatorData as ProportionsTable };
